module.exports = __webpack_public_path__ + "a1c3b54a2a554fe5031d68da97dfce3e.gif";